const sm4 = require("./sm4");

const KEY = "0123456789abcdeffedcba9876543210"

export const encryptSm4 = (data)=>{
   return  sm4.encrypt(data,KEY)
}

